import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useOrderTrackerIconSignatureUpdate = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: (fileId: string) =>
      put2(
        `/internal/secure/pos/v1/orderTracker/settings/upload/icons/${branchId}/${fileId}`,
        {}
      ),
  });
  return mutation;
};

export default useOrderTrackerIconSignatureUpdate;
